import { v4 as uuid } from 'uuid';

import { deferredPromise, IDeferredPromise } from '@/utils/deferredPromise';
import { IDispatchMessage } from '~/api/messages/IDispatchMessage';

export const DEFERRED_MESSAGE_TIMEOUT = 60000; // One minute.

export class DeferredMessage<T extends Partial<IDispatchMessage> = IDispatchMessage> {
  readonly deferred: IDeferredPromise<T>;
  readonly id: string;
  readonly payload: T;

  constructor(payload?: Partial<IDispatchMessage>, timeout = DEFERRED_MESSAGE_TIMEOUT) {
    this.id = uuid();
    this.deferred = deferredPromise<T>(timeout);
    this.payload = <T> {
      correlationKey: this.id,
      ...payload,
    };
  }

  toJSON() {
    return this.payload;
  }

  toString() {
    return JSON.stringify(this.toJSON());
  }
}
